import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCarFrontView: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCarFrontView"><Path fillRule="evenodd" clipRule="evenodd" d="M6.60303 4H17.397L21.137 9.5H22.9998V11H22V20H16.5V17.9286H7.5V20H2V11H1V9.5H2.86303L6.60303 4ZM8 14H5V12.5H8V14ZM19 14H16V12.5H19V14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCarFrontView;
